/* V_NUF_LP_01 | Add Light Labs Testing Badge to Main Landing Page
 * Waits for the variant body class from c-intelligems-tests.js, then:
 * - drops the badge slots the active variant does not use,
 * - for Var B, moves the slot to directly under the One-Time Purchase link
 *   (fb-landing-part2 injects that link + the perks box right after each ATC,
 *   so the slot rendered after the ATC ends up below the perks box),
 * - loads the Light Labs embed script once. Control never loads it,
 * - opens the Light Labs report when the card is clicked, by clicking the
 *   (hidden) report button the embed renders inside the slot's panel.
 */
(function () {
  var VARIANT_PLACEMENTS = {
    'c-lightLabsVarA': ['a-mobile', 'a-desktop'],
    'c-lightLabsVarB': ['b'],
  };
  var started = false;
  var observer;

  function placeUnderOneTimeLink(slot) {
    var atc = slot.previousElementSibling;
    while (atc && atc.tagName !== 'BUTTON') atc = atc.previousElementSibling;
    if (!atc) return;
    var link = atc.nextElementSibling;
    var anchor = link && link.classList.contains('onetime-purchase-link') ? link : atc;
    if (anchor.nextElementSibling !== slot) anchor.insertAdjacentElement('afterend', slot);
  }

  function openReport(slot) {
    var REPORT_BUTTON = '.ll-inline-report-link';
    var button = slot.querySelector(REPORT_BUTTON);
    if (button) {
      button.click();
      return;
    }
    // Embed still loading: open as soon as the report button renders
    if (slot.cReportPending) return;
    slot.cReportPending = true;
    var pending = new MutationObserver(function () {
      var ready = slot.querySelector(REPORT_BUTTON);
      if (!ready) return;
      pending.disconnect();
      slot.cReportPending = false;
      ready.click();
    });
    pending.observe(slot, { childList: true, subtree: true });
  }

  function loadScript(src) {
    if (!src || document.querySelector('script[src="' + src + '"]')) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }

  function start(variantClass) {
    started = true;
    if (observer) observer.disconnect();

    var placements = VARIANT_PLACEMENTS[variantClass];
    var src = '';

    document.querySelectorAll('.c-lightlabs-badge').forEach(function (slot) {
      var placement = slot.getAttribute('data-c-placement');
      if (placements.indexOf(placement) === -1) {
        slot.remove();
        return;
      }
      if (placement === 'b') placeUnderOneTimeLink(slot);
      slot.querySelector('.c-lightlabs-card').addEventListener('click', function () {
        openReport(slot);
      });
      src = src || slot.getAttribute('data-c-script-src');
    });

    loadScript(src);
  }

  function check() {
    if (started || !document.querySelector('.c-lightlabs-badge')) return;
    Object.keys(VARIANT_PLACEMENTS).some(function (variantClass) {
      if (!document.body.classList.contains(variantClass)) return false;
      start(variantClass);
      return true;
    });
  }

  function init() {
    check();
    if (started) return;
    observer = new MutationObserver(check);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
